import { Box } from '@mui/material'
import { EmtTypography, EmtModal, EmtButton } from 'emt-components-v2'
import NextImage from 'next/image'
import VariantImages from '@/assets/VariantImages'
import useIsResponsive from '@/hooks/useIsResponsive'
// import { useTranslation } from 'next-i18next'
// import { serviceConfig } from '@/components/pages/pet-sitter/reservations/NewRequest/NewRequest'

interface RequestSentModalProps {
  title: string | undefined
  subtitle: string | undefined
  service: string | undefined
  serviceKey: string | undefined
  dateTimeInstances: any[]
  info?: string | React.ReactNode
  open: boolean
  leftIcon?: React.ReactNode
  leftIconClassName?: string
  state?: string
  setOpen: (open: boolean) => void
  onClickButton: () => void
}

const RequestSentModal: React.FC<RequestSentModalProps> = ({
  title,
  subtitle,
  open,
  info,
  service,
  serviceKey,
  dateTimeInstances,
  leftIcon,
  leftIconClassName,
  state = 'pending',
  setOpen,
  onClickButton,
}) => {
  // const { t } = useTranslation('petsitter')
  // const config = serviceKey ? serviceConfig[serviceKey] || {} : {}
  const [isMobile] = useIsResponsive()

  return (
    <EmtModal
      open={open}
      fullScreenMobile
      onClose={() => {
        setOpen(false), onClickButton()
      }}
      sx={{
        '& .inner-box': { width: '600px', maxWidth: isMobile ? '100vw' : '90vw' },
        '& .children-box': { padding: '32px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <NextImage src={VariantImages.Sent} width={145} height={76} alt="Request sent" />
        <EmtTypography variant="h4" fontWeight={800}>
          {title}
        </EmtTypography>
        <Box
          sx={{
            textAlign: 'left',
          }}
        >
          {info}
        </Box>
        <EmtTypography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
          {subtitle}
        </EmtTypography>
        {/* <>
          {dateTimeInstances &&
            dateTimeInstances.map((instance, index) => {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                    border: '1px solid #AE59C6',
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    padding: '12px',
                    minWidth: '0',
                    width: '100%',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        width: 38,
                        height: 38,
                        overflow: 'hidden',
                        borderRadius: '12px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexShrink: '0',
                        color: (theme: any) => (theme.palette as any).purple.dark,
                      }}
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(136.18deg, rgba(247, 226, 254, 0.76) 0.50%, #F7E2FE 100%)',
                          pointerEvents: 'none',
                        }}
                      />
                      <Box sx={{ position: 'relative', display: 'flex' }}>
                        {leftIconClassName && <EmtIcon className={leftIconClassName} />}
                        {leftIcon && leftIcon}
                      </Box>
                    </Box>
                    <Box sx={{ maxWidth: '100%', minWidth: '0' }}>
                      <EmtTypography variant="body1" color="#1D1929" fontWeight="700">
                        {service}
                      </EmtTypography>
                      <EmtTypography
                        variant="body2"
                        color="#1D1929"
                        sx={{
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          textAlign: 'left',
                        }}
                      >
                        {config.dateTimeBoxTitle ? config.dateTimeBoxTitle(instance) : instance.date}
                      </EmtTypography>
                    </Box>
                  </Box>
                  <EmtChip
                    color={state}
                    label={t(`reservationCard.${state}`)}
                    sx={{
                      fontWeight: '600',
                    }}
                  />
                </Box>
              )
            })}
        </> */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            justifyContent: 'center',
            position: isMobile ? 'sticky' : 'relative',
            bottom: isMobile ? '30px' : 'auto',
          }}
        >
          <EmtButton fullWidth size="medium" color="purple" onClick={onClickButton}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <EmtTypography variant="body2" fontWeight="700">
                Accéder à la messagerie
              </EmtTypography>
            </Box>
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default RequestSentModal
